import React, { Component } from 'react';
import { style, theme } from 'constants';
import { Link, View, Text, Animated } from 'core';
import * as actions from 'actions';
import { lang } from 'lang';

const styles = style({
  holder: {
    height: 50,
    borderWidth: 1,
    borderRadius: 25
  },
  content: {
    paddingHorizontal: 15,
    height: 48,
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    paddingHorizontal: 5,
    minWidth: 230,
    textAlign: 'center',
    lineHeight: 48
  },
  error: {
    color: theme.error_color,
    padding: 10,
    width: 300,
    textAlign: 'center'
  }
});

export class Button extends Component {
  state = { loadingAnim: new Animated.Value(300) };
  startAnim = flag => {
    this.state.loadingAnim.setValue(flag ? 300 : 50);
    Animated.timing(this.state.loadingAnim, {
      toValue: flag ? 50 : 300,
      duration: 300
    }).start();
  };
  componentDidUpdate(prev) {
    const { status, onSuccess } = this.props;
    if (status && status.is_success && onSuccess) {
      onSuccess();
      actions.fetch.markFinished(status.type);
    }
    prev.status && prev.status.is_loading && status && !status.is_loading && this.startAnim(false);
    prev.status && !prev.status.is_loading && status && status.is_loading && this.startAnim(true);
  }
  componentWillUnmount() {
    const { status } = this.props;
    status && (status.is_error || status.is_success) && actions.fetch.markFinished(status.type);
  }
  render() {
    const { style, title_style, content_style, status, color, ...props } = this.props;
    return (
      <View style={{ alignItems: 'center' }}>
        <Link
          animatedContent
          color={color || theme.primary_color}
          loading={status && status.is_loading}
          style={[styles.holder, style]}
          content_style={[styles.content, content_style, { width: this.state.loadingAnim, borderColor: color || theme.primary_color }]}
          title_style={[styles.title, title_style]}
          {...props}
        />
        {status && status.is_error ? <Text style={styles.error}>{lang.ERROR[status.error_message] || status.error_message}</Text> : null}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/core/button.js